// List of allowed country codes (ISO 3166-1 alpha-2)
export const ALLOWED_COUNTRIES = [
  'US',  // United States
  'GB',  // United Kingdom
  'CA',  // Canada
  'AU',  // Australia
  'NZ',  // New Zealand
  'SG',  // Singapore
  'AE',  // United Arab Emirates
  'CH',  // Switzerland
  'DE',  // Germany
  'FR',  // France
  'NL',  // Netherlands
  'JP',  // Japan
  'KR',  // South Korea
] as const;

// Geo-locking configuration
export const GEO_CONFIG = {
  enabled: false,  // Disabled by default
  allowedCountries: ALLOWED_COUNTRIES,
  // Add more configuration options as needed
} as const; 